<template>
  <div class="card">
    <div class="card-header d-flex align-items-center">
      <i class="icon-refresh"></i> Filtrer
    </div>
    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-6">
          <label>Créé après le</label>
          <Datepicker
            v-model="filters.begin"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></Datepicker>
        </div>
        <div class="form-group col-sm-6">
          <label>Créé avant le</label>
          <Datepicker
            v-model="filters.end"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></Datepicker>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-6">
          <label>Nom</label>
          <input
            class="form-control"
            v-model="filters.name"
            placeholder="Nom du contenu"
          />
        </div>
        <div class="form-group col-sm-6 d-flex flex-column">
          <label class="mb-1">Publication</label>
          <el-radio-group v-model="filters.publishedStatus">
            <el-radio :label="null">Tout voir</el-radio>
            <el-radio label="published">Publié</el-radio>
            <el-radio label="not-published">Non publié</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        @click="applyFilters"
      >
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
      <button
        v-if="hasPermission($store.state.user, writePermission)"
        type="button"
        class="btn btn-sm btn-primary ml-05"
        @click="$emit('add')"
      >
        <i class="fa fa-plus"></i>&nbsp; Ajouter
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker,
  },

  props: {
    writePermission: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      filters: {
        begin: null,
        end: null,
        name: "",
        publishedStatus: null,
      },
    };
  },

  methods: {
    applyFilters() {
      this.$emit("apply", this.filters);
    },
  },
};
</script>
